import React from "react";
import { MenuProvider } from "../Shared/Context/Menu/MenuContext";
import { useAuth } from "../Shared/Hooks/useAuth";

const importAuthenticated = () =>
  import("../Modules/Authenticated").then((module) => ({
    default: module.Authenticated,
  }));

const importUnAuthenticated = () =>
  import("../Modules/UnAuthenticated").then((module) => ({
    default: module.UnAuthenticated,
  }));

const Authenticated = React.lazy(importAuthenticated);
const UnAuthenticated = React.lazy(importUnAuthenticated);
const ChangePasswordPage = React.lazy(() =>
  import("../Modules/ChangePasswordPage").then((module) => ({
    default: module.ChangePasswordPage,
  }))
);

// Start downloading the chunk this visitor will most likely need right away,
// in parallel with the login check, instead of after the login check finishes.
// React.lazy reuses the already-requested chunk, so nothing is loaded twice.
const hasStoredSession = (): boolean => {
  try {
    return !!localStorage.getItem("rt");
  } catch {
    return false;
  }
};

if (hasStoredSession()) {
  importAuthenticated().catch(() => undefined);
} else {
  importUnAuthenticated().catch(() => undefined);
}

export const ContextRoutes = () => {
  const { isAuthenticated, mustChangePassword } = useAuth();

  return (
    <div>
      {isAuthenticated ? (
        mustChangePassword ? (
          <ChangePasswordPage />
        ) : (
          <MenuProvider>
            <Authenticated />
          </MenuProvider>
        )
      ) : (
        <UnAuthenticated />
      )}
    </div>
  );
};
